import UtilityPageNav from "content-ui/utilityPages/components/utilityPageNav";
import Headline from "./components/headline";
import { ContactUsPageData } from "./types";
import classNames from "classnames";
import ContactForm from "./components/contactForm";
import MapView from "./components/mapView";
import { Faq } from "components/faq/faq";

interface ContactUsViewProps {
  data: ContactUsPageData;
}

const ContactUsView = ({ data }: ContactUsViewProps) => {
  const innerContainerClasses = classNames(
    "relative flex flex-col pb-[100px] md:mx-auto lg:flex-row md:max-w-[1040px] lg:max-w-[1220px] px-5 lg:px-0"
  );

  return (
    <main
      data-page-type="contact-us"
      className="bg-[#F6F6F6] text-[16px] leading-[130%] text-black-rock"
    >
      <div className={innerContainerClasses}>
        <UtilityPageNav />
        <div className="mt-[1.25rem]">
          <Headline headline={data.headline} subhead={data.subhead} />
          <ContactForm />
          <MapView address={data.address} mapsLink={data.mapsLink} />
          <Faq title={"FAQs" as any} faq={data.faq} />
        </div>
      </div>
    </main>
  );
};

export default ContactUsView;
